import { useMutation } from "@tanstack/react-query";

import { gql } from "@examspark/api";
import { Resource } from "@examspark/types";

export const useMutationCreateIssue = () => {
  return useMutation({
    mutationFn: async (input: Partial<Resource>) => {
      gql.issue.createIssue(input);
    },
  });
};
